const allowedVariants = {
    horizontal: {
        en: {
            'color-white': 'color-white.svg',
            'color-black': 'color-black.svg',
            'mono-black': 'mono-black.svg',
        },
        uk: {
            'color-white': 'color-white.svg',
            'color-black': 'color-black.svg',
            'mono-black': 'mono-black.svg',
        },
    },
    icon: {
        default: {
            lun_icon: 'lun_icon.svg'
        },
    },
} as const;

type IconType = keyof typeof allowedVariants;

type IconStyle<T extends IconType> =
    keyof typeof allowedVariants[T];

// type IconVariant<
//     T extends IconType,
//     S extends IconStyle<T>
// > = keyof typeof allowedVariants[T][S];

export const useLunIcon = <T extends IconType, S extends IconStyle<T>>(type: T, style: S) => {
    const variants = allowedVariants[type][style];

    return <V extends keyof typeof variants>(variant: V) => {
        const iconFile = variants[variant];

        return require(`assets/icons/lun/${type}/${style}/${iconFile}`);
    };
};
